import { Routes } from '@angular/router';

import { adminGuard } from './admin.guard';
import { userGuard } from './user.guard';


// =========================
// PUBLIC
// =========================

import { Home }
from './pages/home/home';

import { LoginComponent }
from './pages/login/login';

import { Register }
from './pages/register/register';

import { ForgotPasswordComponent }
from './pages/forgot-password/forgot-password';

import { ResetPasswordComponent }
from './pages/reset-password/reset-password';

import { ProductDetails }
from './pages/product-details/product-details';


// =========================
// USER
// =========================

import { Cart }
from './pages/cart/cart';

import { Checkout }
from './pages/checkout/checkout';

import { Success }
from './pages/success/success';

import { PaymentSuccess }
from './pages/payment-success/payment-success';

import { PaymentFail }
from './pages/payment-fail/payment-fail';

import { PaymentCancel }
from './pages/payment-cancel/payment-cancel';

import { Orders }
from './pages/orders/orders';

import { Account }
from './pages/account/account';

import { Profile }
from './pages/profile/profile';
// =========================
// EXTRA PAGES
// =========================

import { Safety }
from './pages/safety';

import { Premium }
from './pages/premium';

import { Help }
from './pages/help';

import { Offers }
from './pages/offers/offers';

import { Rewards }
from './pages/rewards/rewards';

import { Complaint }
from './pages/complaint';


// =========================
// ADMIN
// =========================

import { Admin }
from './admin/admin';

import { Dashboard }
from './pages/dashboard/dashboard';

import { AdminProducts }
from './pages/admin-products/admin-products';

import { AdminOrders }
from './pages/admin-orders/admin-orders';

import { AdminInvoice }
from './pages/admin-invoice/admin-invoice';

import { AdminReceipt }
from './pages/admin-receipt/admin-receipt';

import { AdminComplaints }
from './pages/admin-complaints/admin-complaints';

import { AdminCategories }
from './pages/admin-categories/admin-categories';

import { AdminBanners }
from './pages/admin-banners/admin-banners';

import { AdminCustomers }
from './pages/admin-customers/admin-customers';

import { AdminFeatures }
from './pages/admin-features/admin-features';

import { AdminSidebarLinks }
from './pages/admin-sidebar-links/admin-sidebar-links';

import { AdminShopMore }
from './pages/admin-shop-more/admin-shop-more';

import { AdminPopularBrands }
from './pages/admin-popular-brands/admin-popular-brands';

import { AdminFooter }
from './pages/admin-footer/admin-footer';

import { AdminSettings }
from './pages/admin-settings/admin-settings';

import { AdminHomepageDesign }
from './pages/admin-homepage-design/admin-homepage-design';


// =========================
// ANALYTICS
// =========================

import { Finance }
from './pages/finance/finance';

import { Inventory }
from './pages/inventory/inventory';

import { Analytics }
from './pages/analytics/analytics';


// =========================
// PURCHASE
// =========================

import { PurchaseManagement }
from './admin/purchase-management/purchase-management';

import { PurchaseHistory }
from './pages/purchase-history/purchase-history';


export const routes: Routes = [

  // =========================
  // PUBLIC
  // =========================

  {
    path: '',
    component: Home
  },

  {
    path: 'login',
    component: LoginComponent
  },

  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },

  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },

  {
  path: 'register',
  component: Register
},

  {
    path: 'product/:id',
    component: ProductDetails
  },


  // =========================
  // CATEGORY PAGE
  // =========================

  {
    path: 'category/:id',

    loadComponent: () =>
      import(
        './pages/category-page/category-page'
      )
        .then(
          m => m.CategoryPage
        )
  },


  // =========================
  // USER
  // =========================

  {
    path: 'cart',
    component: Cart
  },

  {
    path: 'orders',
    component: Orders,
    canActivate: [userGuard]
  },

  {
  path: 'account',
  component: Account,
  canActivate: [userGuard]
},

{
  path: 'profile',
  component: Profile,
  canActivate: [userGuard]
},

  {
    path: 'checkout',
    component: Checkout,
    canActivate: [userGuard]
  },

  {
    path: 'success',
    component: Success,
    canActivate: [userGuard]
  },

  {
    path: 'payment-success',
    component: PaymentSuccess,
    canActivate: [userGuard]
  },

  {
    path: 'payment-fail',
    component: PaymentFail,
    canActivate: [userGuard]
  },

  {
    path: 'payment-cancel',
    component: PaymentCancel,
    canActivate: [userGuard]
  },


  // =========================
  // EXTRA
  // =========================

  {
    path: 'safety',
    component: Safety
  },

  {
    path: 'premium',
    component: Premium
  },

  {
    path: 'help',
    component: Help
  },

  {
    path: 'offers',
    component: Offers
  },

  {
    path: 'rewards',
    component: Rewards
  },

  {
    path: 'complaint',
    component: Complaint
  },


  // =========================
  // ADMIN PANEL
  // =========================

  {
    path: 'admin',

    component: Admin,

    canActivate: [
      adminGuard
    ],

    children: [

      {
        path: '',

        redirectTo:
          'dashboard',

        pathMatch:
          'full'
      },


      // =========================
      // DASHBOARD
      // =========================

      {
        path: 'dashboard',

        component:
          Dashboard
      },


      // =========================
      // PRODUCTS
      // =========================

      {
        path: 'products',

        component:
          AdminProducts
      },


      // =========================
      // BULK PRODUCT IMPORT
      // =========================

      {
        path: 'products/import',

        loadComponent: () =>
          import(
            './pages/admin-product-import/admin-product-import'
          )
            .then(
              m => m.AdminProductImport
            )
      },


      // =========================
      // CATEGORIES
      // =========================

      {
        path: 'categories',

        component:
          AdminCategories
      },


      // =========================
      // HOMEPAGE DESIGN
      // (সেকশন ক্রম, ব্যানার, পপুলার ক্যাটাগরি/ব্র্যান্ড)
      // =========================

      {
        path: 'homepage-design',

        component:
          AdminHomepageDesign
      },


      // =========================
      // BANNERS
      // =========================

      {
        path: 'banners',

        component:
          AdminBanners
      },


      // =========================
      // HOMEPAGE FEATURES
      // =========================

      {
        path: 'features',

        component:
          AdminFeatures
      },


      // =========================
      // SIDEBAR MENU LINKS
      // =========================

      {
        path: 'sidebar-links',

        component:
          AdminSidebarLinks
      },


      // =========================
      // SHOP & GET MORE
      // =========================

      {
        path: 'shop-more',

        component:
          AdminShopMore
      },


      // =========================
      // POPULAR BRANDS
      // =========================

      {
        path: 'popular-brands',

        component:
          AdminPopularBrands
      },


      // =========================
      // FOOTER MANAGEMENT
      // =========================

      {
        path: 'footer',

        component:
          AdminFooter
      },


      // =========================
      // SITE SETTINGS (LOGO)
      // =========================

      {
        path: 'settings',

        component:
          AdminSettings
      },


      // =========================
      // CUSTOMERS
      // =========================

      {
        path: 'customers',

        component:
          AdminCustomers
      },


      // =========================
      // ORDERS
      // =========================

      {
        path: 'orders',

        component:
          AdminOrders
      },

      {
  path: 'orders/:id/invoice',

  component:
    AdminInvoice
},

{
  path: 'orders/:id/receipt',

  component:
    AdminReceipt
},


      // =========================
      // COMPLAINTS
      // =========================

      {
        path: 'complaints',

        component:
          AdminComplaints
      },


      // =========================
      // ANALYTICS
      // =========================

      {
        path: 'analytics',

        component:
          Analytics
      },


      // =========================
      // FINANCE
      // =========================

      {
        path: 'finance',

        component:
          Finance
      },


      // =========================
      // INVENTORY
      // =========================

      {
        path: 'inventory',

        component:
          Inventory
      },


      // =========================
      // PURCHASE MANAGEMENT
      // =========================

      {
        path:
          'purchase-management',

        component:
          PurchaseManagement
      },


      // =========================
      // PURCHASE HISTORY
      // =========================

      {
        path:
          'purchase-history',

        component:
          PurchaseHistory
      },


      // =========================
      // SUPPLIERS
      // =========================

      {
        path: 'suppliers',

        loadComponent: () =>
          import(
            './admin/suppliers/suppliers'
          )
            .then(
              m => m.Suppliers
            )
      }

    ]
  },


  // =========================
  // FALLBACK
  // =========================

  {
    path: '**',

    redirectTo: ''
  }

];